<ng-container *ngIf="accountsInfo">
    <div *ngIf="accountsInfo.contractSummaryResponse && accountsInfo.contractSummaryResponse.responseCode == '200' && accountsInfo.contractSummaryResponse.contractSummary"
        [attr.data-qa]="'sia-wrapper'">
        <div class="container"
            *ngFor="let contract of accountsInfo.contractSummaryResponse.contractSummary; let index = index">
            <app-account [contract]="contract" [redesign]="redesign"></app-account>
        </div>

        <!-- contractsummary v2 CSR non-privileged  user -->
        <ng-container *ngIf="!accountsInfo.contractSummaryResponse.contractSummary">
            <div class="container" *ngIf="genericService.usr_csr">
                <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
                    <div class="row contract-header">
                        <div class="col-sm-6 col-md-8 product-title">
                            <h3 class="h4 mt-0" [attr.data-qa]="accountsInfo.businessUnit">
                                <span class="product-title-lob">{{accountsInfo.businessUnit}}</span>
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="alert alert-danger alert-inline" role="alert"
                                [attr.data-qa]="accountsInfo.businessUnit +'_warning_container'">
                                <span class="sr-only">warning</span>
                                <error-msg msgcode="csr"></error-msg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
<ng-container *ngIf="accountsInfo.responseCode != 200; else successNoData">
    <div class="container" [attr.data-qa]="'ucd-error-container'">
        <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
            <h3 class="h4 product-title mt-0" [attr.data-qa]="'ucd-error-buName'">
                <span class="product-title-lob">{{accountsInfo.businessUnit}}</span>
            </h3>
            <div class="row contract-header">
                <div class="col-sm-6 col-md-8"></div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-danger alert-inline" role="alert" [attr.data-qa]="'ucd-error-alertbox'">
                        <span class="sr-only">warning</span>
                        <ng-container *ngIf="genericService.usr_csr; else client">
                            <div class="csr-err-msg" [attr.data-qa]="'ucd-csr-error-text'">
                                <error-msg [lob]="accountsInfo.businessUnit" msgcode="missing"
                                    *ngIf="accountsInfo.responseCode != 412"></error-msg>
                                <error-msg msgcode="csr" *ngIf="accountsInfo.responseCode == 412"></error-msg>
                            </div>
                        </ng-container>
                        <ng-template #client>
                            <div [attr.data-qa]="'ucd-error-p-text'" class="client-err-msg">
                                <error-msg [lob]="accountsInfo.businessUnit" msgcode="missing"></error-msg>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #successNoData>
    <div *ngIf="!accountsInfo.contractSummaryResponse || accountsInfo.contractSummaryResponse.responseCode != '200' || !accountsInfo.contractSummaryResponse.contractSummary"
        [attr.data-qa]="'sia-wrapper-error'">
        <div class="container">
            <div class="product-box col-xs-12 pt-4 pb-4" [attr.data-ct-analytics]="service-error">
                <div *ngIf="accountsInfo.businessUnit" class="row contract-header">
                    <div class="col-sm-6 col-md-8">
                        <h3 class="h4 product-title mt-0" [attr.data-qa]="'sia-wrapper-error-buname'">
                            <span class="product-title-lob">{{ accountsInfo.businessUnit }}</span>
                        </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" [attr.data-qa]="'sia-wrapper-error-msg-container'">
                        <div class="alert alert-danger alert-inline mb-0" role="alert">
                            <span class="sr-only">warning</span>
                            <ng-container *ngIf="genericService.usr_csr; else client">
                                <div class="csr-err-msg">
                                    <ng-container
                                        *ngIf="!accountsInfo.portfolioResponse || (accountsInfo.portfolioResponse && accountsInfo.portfolioResponse.responseCode === '200' && accountsInfo.portfolioResponse.portfolio && accountsInfo.portfolioResponse.portfolio.contracts && accountsInfo.portfolioResponse.portfolio.contracts.length === 0); else techDifficulty">
                                        <error-msg msgcode="csr"></error-msg>
                                    </ng-container>
                                    <ng-template #techDifficulty>
                                        <error-msg [lob]="accountsInfo.businessUnit" msgcode="missing"></error-msg>
                                    </ng-template>
                                </div>
                            </ng-container>
                            <ng-template #client>
                                <div class="client-err-msg">
                                    <error-msg [lob]="accountsInfo.businessUnit" msgcode="missing"></error-msg>
                                </div>
                            </ng-template>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
    
</ng-container>